import React, { useState, useEffect } from "react";
import { FaCalendarAlt, FaClock, FaCommentAlt, FaComments } from "react-icons/fa";
import { useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Comments from "../../components/Comments/Comments";
import CommentModal from "../../components/CommentModal/CommentModal";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Preloader from "../../components/Preloader/Preloader";
import Tags from "../../components/Tags/Tags";
import "./BlogSingle.scss";
import "./Responsive.scss";
import Skeleton from "react-loading-skeleton";

const BlogSingle = (props) => {
  let blogId;
  if (props.location.state === undefined) {
    props.history.push("/404");
  } else {
    blogId = props.location.state.blogId;
  }
  const [commentModal, setCommentModal] = useState(false);
  const [preloader, setPreloader] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [resetPage, setResetPage] = useState(false);
  const [blog, setBlog] = useState("");
  const [comment, setComment] = useState([]);
  const [tags, setTags] = useState([]);
  const user = useSelector((state) => state.user);

  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "بلاگ", link: "/blog" },
    // { title: "عنوان بلاگ", link: "/blog/عنوان بلاگ" },
    { title: `${blog && blog.title}` },
  ];

  useEffect(async () => {
    Config.pageUp();
    await getBlog();
  }, [resetPage]);

  const getBlog = () => {
    setPreloader(true);
    axios
      .get(
        `/blog/getblog/${blogId}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        if (result.status === 200) {
          setBlog(result.data.data);
          setComment(result.data.data.blogComment);
          let tg = result.data.data.keys;
          setTags(tg);
          setPreloader(false);
        }
      })
      .catch((error) => {
        setPreloader(false);
        // console.log(error);
      });
  };

  const showCommentModal = () => {
    let body = document.body;
    body.style.overflowY = "hidden";
    setCommentModal(true);
  };
  const hideCommentModal = () => {
    let body = document.body;
    body.style.overflowY = "auto";
    setCommentModal(false);
  };

  const commentSubmitHandler = (commentText, recaptcha) => {
    if (recaptcha !== "") {
      setShowSpinner(true);
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

      let raw = JSON.stringify({
        Id: blogId,
        Message: commentText,
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(Config.apiPath + "/blog/SendMessage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 200) {
            toast.success(<div>{result.messages}</div>);
            setShowSpinner(false);
            setCommentModal(false);
            setResetPage(!resetPage);
          }
        })
        .catch((error) => {
          setShowSpinner(false);
          // console.log("error", error);
        });
    } else {
      toast.error("گزینه من ربات نیستم فعال نیست!");
      setShowSpinner(false);
    }
  };

  return (
    <section className="singleBlogWrapper mobile">
      <Helmet>
        <title>
          {Config.helmetTitle} | {`${blog?.title}`}
        </title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && <Preloader active={preloader} />} */}
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="blogContents">
        <div className="desktop">
          <div className="blogContent">
            <div className="blogContentText">
              <p className="blogTitle">{blog && blog.title}</p>
              <div className="imageFigure">
                {blog.length <= 0 || !blog ? (
                  <Skeleton containerClassName="homeSliderSkeletonWrapper" className="skeleton" />
                ) : (
                  <img src={blog && blog.image} alt={blog && blog.title} />
                )}
              </div>
              <div className="blogTools">
                <div className="dateTime">
                  <p className="date">
                    <FaCalendarAlt />
                    {blog && blog.createDateTime}
                  </p>
                  <p className="time">
                    <FaClock /> 13:23
                  </p>
                </div>
                <p className="commentCount">
                  <FaComments /> {comment && comment.length} دیدگاه
                </p>
              </div>
              <div className="blogText" dangerouslySetInnerHTML={{ __html: blog && blog.content }}></div>
            </div>

            <div className="blogTags">{blog && tags.length > 0 && <Tags tagData={tags} />}</div>
          </div>
          <div className="blogComments">
            <p className="title">
              <FaCommentAlt /> دیدگاه کاربران ({comment && comment.length})
            </p>
            {user.length > 0 ? (
              <button className="showCommentModal" onClick={(e) => showCommentModal(e)}>
                ارسال دیدگاه
              </button>
            ) : (
              <p className="loginWarning">برای ارسال دیدگاه باید وارد حساب کاربری خود شوید</p>
            )}

            <Comments commentData={comment} />
          </div>
        </div>
      </div>
      {commentModal && (
        <CommentModal
          show={commentModal}
          showSpinner={showSpinner}
          submitHandler={commentSubmitHandler}
          hideCommentModal={hideCommentModal}
        />
      )}
    </section>
  );
};

export default React.memo(BlogSingle);
